import type { AsyncNamespace } from '@otto-ec/global-resources/nexus'
import type { NexusCmp } from './nexus-cmp.type'

declare global {
  /*                                   */
  interface NexusInterfaces {
    /**
 *
 */
    [NEXUS_CMP_NAMESPACE]: AsyncNamespace<NexusCmp>
  }
}
export const NEXUS_CMP_NAMESPACE = 'cmp'
